import { render, staticRenderFns } from "./Toaster.vue?vue&type=template&id=9b8f03b8&scoped=true"
import script from "./Toaster.vue?vue&type=script&lang=js"
export * from "./Toaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8f03b8",
  null
  
)

export default component.exports